import { Injectable } from '@angular/core';

import { RestService } from "../../core/services/rest.service";
import { Funcionario } from "./funcionario.model";
import { apiName } from "./data.service";

@Injectable()
export class FuncionarioApiService {

  constructor(
    private _restService: RestService
  ) { }

  onPost(object: Funcionario, done: any) {
    this._restService.onPost(apiName, object, done);
  }

  onPut(object: Funcionario, done: any) {
    this._restService.onPut(apiName, object, done);
  }

  onDelete(objectId: number, done: any) {
    this._restService.onDelete(apiName, objectId, done);
  }

  onGetAll(done: any) {
    var filter: any = {"order":"nome"};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetById(objectId: number, done: any) {
    this._restService.onGet(apiName + '/' + objectId + '?', done);
  }

  onGetByPerson(personId: number, done: any) {
    var filter: any = {"where":{"pessoaId":personId}};
    this._restService.onGetPost(apiName, filter, done);
  }

  onGetApiUrl() {
    return apiName;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/funcionarios/funcionario-api.service.ts
 **/